/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js";

export default {
  getList({ commit }, param) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/user/student/student-deal?${new URLSearchParams(param)}`)
        .then((response) => {
          const data = response.data.data;
          if (data && data.pagination) {
            commit("SET_LIST_WITH_PAGINATION", data);
          } else {
            commit("SET_LIST", data);
          }
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
